<ng-container *ngIf="suggests$ | async as suggests">
  <ul
    data-e2e="street-suggest"
    *ngIf="suggests?.length"
    [class.show]="show$ | async"
  >
    <li *ngFor="let suggest of suggests" (click)="applySuggest(suggest)">
      {{ suggest.description }}
    </li>
  </ul>
</ng-container>
